export const MAX_PERCENTAGE = 99;
export const MAX_TAG_LENGTH = 40;
export const REFETCH_DELAY = 5000; // 5 seconds
export const LONG_REFETCH_DELAY = 30000; // 30 seconds
export const TIMEOUT_API = 60 * 1000; // 60 seconds
export const NO_STALE_TIME = 0;
export const TWENTY_FOUR_HOURS_IN_MS = 24 * 60 * 60 * 1000; // Used for react query cache time when data is not expected to change often
export const MAX_LENGTH_ACTIVATION_CODE = 100;

export const PAYMENT_METHODS = [
	'coin',
	'card',
	'refund',
	'promotion',
	'cash',
	'cashless',
	'bip_drive',
	'virtual_credit',
	'marketpay',
	'app',
	'tag',
	'voucher',
	'bundle', // 'it's pack but api still uses 'bundle''
	'token',
	'qr',
] as const;

export const TRANSACTION_STATUS = [
	'completed',
	'pending',
	'in_process',
	'refund',
	'denied', // payment denied for example for insufficient balance, fraud suspicion, etc
	'partial_refund',
	'canceled',
	'refund_denied',
	'confirmed',
	'refund_pending',
	'delivery_failed', // product not delivered
	'payment_failed', // error payment provider
	'timeout',
	'expired',
	'failed',
	'error',
	'manual_fail',
	'auto_fail',
] as const;
